module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('table', {
    staticClass: "chapter-title-corner-decorations",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-left",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_left.png"
    }
  })])]), _c('td', {
    staticClass: "chapter-title-corner-decoration-middle-column"
  }), _c('td', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-right",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_right.png"
    }
  })])])])])]), _c('div', {
    staticClass: "chapter-title"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-above",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_above.png"
    }
  })])]), _c('h1', {
    staticClass: "chapter-title"
  }, [_c('a', {
    attrs: {
      "id": "__RefHeading___Toc525464174"
    }
  }, [_vm._v("Encontre Lexy Timms:")])]), _c('a', {
    attrs: {
      "id": "__RefHeading___Toc525464174"
    }
  }, [_c('div', {
    staticClass: "chapter-title-decoration-below"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-below-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-below",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_below.png"
    }
  })])])])]), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_c('a', {
    attrs: {
      "id": "__RefHeading___Toc525464174"
    }
  }, [_c('img', {
    staticClass: "section-break-symbol",
    attrs: {
      "alt": "image",
      "height": "93",
      "src": "d2d_images/image030.png",
      "width": "93"
    }
  })])]), _c('a', {
    attrs: {
      "id": "__RefHeading___Toc525464174"
    }
  }, [_c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-l"
  }, [_vm._v("L")]), _vm._v("exy Boletim Informativo")]), _vm._v(":")])]), _c('p', {
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('a', {
    attrs: {
      "id": "__RefHeading___Toc525464174"
    }
  }), _c('a', {
    attrs: {
      "href": "http://eepurl.com/9i0vD",
      "target": "_blank"
    }
  }, [_vm._v("http://eepurl.com/9i0vD")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify"
    }
  }, [_vm._v("Lexy Timms Facebook:")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/SavingForever",
      "target": "_blank"
    }
  }, [_vm._v("https://www.facebook.com/SavingForever")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "justify"
    }
  }, [_vm._v("Lexy Timms Website:")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify",
      "text-decoration": "underline"
    }
  }, [_c('a', {
    attrs: {
      "href": "http://www.lexytimms.com/",
      "target": "_blank"
    }
  }, [_vm._v("http://www.lexytimms.com")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_c('img', {
    staticClass: "section-break-symbol",
    attrs: {
      "alt": "image",
      "height": "268",
      "src": "d2d_images/image028.jpg",
      "width": "358"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_c('img', {
    staticClass: "section-break-symbol",
    attrs: {
      "alt": "image",
      "height": "236",
      "src": "d2d_images/image007.jpg",
      "width": "285"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Quer ler mais ...")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("De "), _c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("GRAÇA")]), _vm._v("?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Cadastre-se no boletim informativo de Lexy Timms")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("E ela o manterá atualizado sobre as novidades, ARCS e muita coisa boa!")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Cadastre-se para novidades e atualizações!")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-decoration": "underline",
      "text-indent": "0"
    }
  }, [_c('a', {
    attrs: {
      "href": "http://eepurl.com/9i0vD",
      "target": "_blank"
    }
  }, [_vm._v("http://eepurl.com/9i0vD")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26807838","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c005.vue
// module id = 72
// module chunks = 0